<template>
  <div id="page-wrapper" v-if="loggedIn">
    <PageHeader></PageHeader>
    <div class="container content-">
      <div class="row">
        <!--div class="hidden-xs col-md-10 col-md-offset-1"-->
        <div class="col-md-12">
          <QuickLinks></QuickLinks>
        </div>
        <div class="row">
          <div class="col-md-4">
            <EplNewProfile></EplNewProfile>
          </div>
          <!-- <ProfileContent class="hidden-xs hidden-sm" :device="'desktop'" :nav="'invite-upgrade'"></ProfileContent> -->
          <section class="col-md-8 invite-upgrade">
            <div class="content-section">
              <section class="side-content">
                <header class="clearfix">
                  <router-link
                    :to="'profile'"
                    href="javascript:void(0)"
                    class="goback hidden-lg hidden-md"
                  >
                    <img width="32" src="/static/images/pngs/back_white.png" alt="< Go Back" />
                  </router-link>
                  <h1>Invite &amp; Upgrade</h1>
                  <p>Share with your friends</p>
                </header>
              </section>
              <div class="content">
                <div
                  v-if="
                    user.features != undefined &&
                      user.features.referral.enabled == true
                  "
                >
                  <p>
                    Upgrade your credit limit by ₹250 for every friend who signs
                    up and gets non-zero credit limit.
                  </p>
                  <span class="referal-code">
                    <input type="text" v-model="user.features.referral.refUrl" readonly />
                    <button
                      type="button"
                      id="copy_link_share"
                      v-clipboard:copy="user.features.referral.refUrl"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >Copy Link</button>
                  </span>
                  <span class="copysuccess"></span>
                  <p>Or</p>
                  <p>Share with your friends</p>
                  <social-sharing
                    :url="user.features.referral.refUrl"
                    title="Hey! I’m inviting you to ePayLater, a buy now pay later service. Sign up using my link and get reward points worth ₹ 50."
                    description="Hey! I’m inviting you to ePayLater, a buy now pay later service. Sign up using my link and get reward points worth ₹ 50."
                    quote="Hey! I’m inviting you to ePayLater, a buy now pay later service. Sign up using my link and get reward points worth ₹ 50."
                    hashtags="Reward"
                    inline-template
                  >
                    <div class="socialshare">
                      <network network="facebook" id="facebook_share">
                        <img src="/static/images/svgs/ic-facebook.svg" alt="Facebook" />
                      </network>
                      <network network="twitter" id="twitter_share">
                        <img src="/static/images/svgs/ic-twitter.svg" alt="Twitter" />
                      </network>
                    </div>
                  </social-sharing>
                </div>
                <div v-else>
                  <p class="text-center default-msg">Something went wrong, please try again later.</p>
                </div>
                <a
                  href="https://s3.ap-south-1.amazonaws.com/epaylater-marketing/Referral+TnC.pdf"
                  class="pull-right terms-conditions"
                  target="_blank"
                >Terms &amp; Conditions</a>
              </div>
            </div>
          </section>
        </div>
        <MobileNav :activeLink="'invite-upgrade'" class="visible-xs"></MobileNav>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import PageHeader from "./EplNewPageHeader/index";
import EplNewProfile from "./EplNewProfile";
// import ProfileContent from './ProfileContent/index'
import QuickLinks from "./EplNewQuickLinks/index";
import MobileNav from "./EplNewMobileNav/index";
import VueClipboard from "vue-clipboard2";
import SocialSharing from "vue-social-sharing";
import $ from "jquery";
import { Facebook, Twitter } from "vue-socialmedia-share";
import { mapGetters } from "vuex";

Vue.use(VueClipboard);
Vue.use(SocialSharing);

export default {
  name: "InviteAndUpgrade",
  data() {
    return {
      //message: 'http://www.testing.com',
      //urll: user.features[0].referral.refUrl
      //url: user.features[0].referral.refUrl
    };
  },
  components: {
    PageHeader,
    EplNewProfile,
    QuickLinks,
    MobileNav,
    Facebook,
    Twitter
  },
  computed: {
    ...mapGetters(["loggedIn", "user"])
  },
  mounted() {
    this.loadurl();
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: "INVITE_AND_UPGRADE"
    });
  },
  methods: {
    myurlcpy() {
      let myurl = this.urll;
    },
    loadurl() {
      let refurl = "";
      if (this.user.features != undefined) {
        refurl = this.user.features.referral.refUrl;
      }
      return refurl;
    },
    onCopy: function(e) {
      $(".copysuccess")
        .text("Copied")
        .fadeIn(500)
        .delay(3000)
        .fadeOut(500);
    },
    onError: function(e) {
      $(".copysuccess")
        .addClass("error")
        .text("Failed to copy")
        .fadeIn(500)
        .delay(3000)
        .fadeOut(500);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../assets/sass/variables";
.content-section {
  min-height: 550px !important;
  background: #fff;
}
.content {
  background: #fff;
  .default-msg {
    padding: 30px 0;
  }
}
.invite-upgrade {
  header {
    background: url("/static/images/svgs/invite-upgrade.svg") no-repeat 90% 15px
      #377cfd;
    border-radius: 6px 6px 0 0;
    background-color: #377cfd;
    padding: 44px 0 30px;
    background-size: 30%;
    @media screen and (max-width: $md) {
      margin: 0 -15px;
      width: auto;
      padding: 30px 0;
      border-radius: 0;
    }

    h1 {
      margin: 0 32px;
      line-height: 30px;
      font-size: 24px;
      /* font-weight: bold;
            text-transform: uppercase; */
      color: #fff;
      span {
        display: block;
        color: #fc7f5a;
      }
    }
    p {
      margin: 0 32px;
      color: #fff;
      font-size: 12px;
    }
  }
  .content {
    padding: 32px;
    h3 {
      margin-top: 0;
      font-weight: 800;
      color: #4b5566;
    }
    p {
      font-size: 14px;
      color: #000;
    }
    .referal-code {
      display: inline-block;
      background: #f5f6f7;
      padding: 12px 25px;
      border-radius: 6px;
      min-width: 65%;
      border: dashed 1px rgba(75, 85, 102, 0.12);
      font-weight: 800;
      margin: 15px 0 25px;
      input[type="text"],
      button {
        border: none;
        background: transparent;
        outline: none;
        &:focus {
          outline: none;
        }
      }
      button {
        float: right;
        font-size: 12px;
        line-height: 20px;
        color: #377cfd;
        font-weight: normal;
      }
      p {
        float: left;
        margin-bottom: 0;
      }
    }
    .terms-conditions {
      font-size: 12px;
      color: #718099;
      opacity: 0.75;
      &:hover {
        opacity: 1;
      }
    }
    .socialshare {
      span {
        display: inline-block;
        margin-right: 12px;
        cursor: pointer;
      }
    }
  }
  .copysuccess {
    background: url("/static/images/pngs/ic-confirmed.png") no-repeat 10px
      center;
    line-height: 22px;
    padding: 16px 25px 16px 38px;
    border-radius: 5px;
    color: #59cd90;
    font-size: 12px;
    background-size: 22%;
    display: none;
    &.error {
      background: url("/static/images/pngs/ic-cancel.png") no-repeat 10px center;
      color: #f45c5f;
      background-size: 18%;
    }
  }
}
@media screen and (max-width: $sm) {
  header {
    .goback {
      display: inline-block;
      margin: 0 32px;
      line-height: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EplNewInviteAndUpgrade.vue